import { render, staticRenderFns } from "./Humm.vue?vue&type=template&id=d487f496"
import script from "./Humm.vue?vue&type=script&lang=js"
export * from "./Humm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports